import { Stack, Typography } from "@mui/material";

interface Props {
  color: string;
  label: string;
}

export const ColorLabel = ({ color, label }: Props) => {
  return (
    <Stack
      spacing={1}
      direction="row"
      alignItems="center"
      justifyContent="center"
    >
      <div
        style={{
          width: "40px",
          height: "4px",
          borderRadius: "4px",
          backgroundColor: color,
        }}
      />

      <Typography>{label}</Typography>
    </Stack>
  );
};
